import { Box, Stack, Typography } from '@mui/material'
import { FC, ReactNode } from 'react'
import { border } from '../../layout/theme/border'
import { themeColor } from '../../layout/theme/color'

interface EmptyStateProps {
  icon: ReactNode
  title: string
  text?: string
  action?: ReactNode
  compact?: boolean
}

/** Icon, title, explanation and an optional action, centred. */
export const EmptyState: FC<EmptyStateProps> = ({ icon, title, text, action, compact }) => (
  <Stack alignItems="center" textAlign="center" spacing={1} sx={{ py: compact ? 4 : 8, px: 3 }}>
    <Box
      sx={{
        'width': 44,
        'height': 44,
        'borderRadius': `${border.radius.md}px`,
        'display': 'flex',
        'alignItems': 'center',
        'justifyContent': 'center',
        'bgcolor': themeColor.slate05,
        'border': `${border.thin} solid ${border.light}`,
        'color': themeColor.slate50,
        'mb': 0.5,
        '& svg': { fontSize: 22 },
      }}
    >
      {icon}
    </Box>
    <Typography sx={{ fontSize: 15, fontWeight: 600, color: themeColor.slate }}>{title}</Typography>
    {text && <Typography sx={{ fontSize: 13.5, color: themeColor.slate50, maxWidth: 420 }}>{text}</Typography>}
    {action && <Box sx={{ pt: 1 }}>{action}</Box>}
  </Stack>
)
